import { CText } from '../@shared/models/text.model';

export class HPData {
    constructor() {
        this.index = 0;
        this.layoutType = '';
        this.layoutContent = {
            banner: {
                image: '',
                link: '',
                scrim: { color: '', alpha: '' },
            },
            button: {
                alignment: '',
                background: { color: '', image: '' },
                height: '',
                width: '',
                title: { text: '' },
                link: '',
            },
            title: { text: '' },
            description: [],
            slider: [],
            meta: { background: '' },
            alignment: '',
            endsIn: '',
            padding: {},
        };
    }

    index?: number;
    layoutType: string;
    layoutContent: Content;
}

export interface Content {
    banner: {
        image: string;
        link: string;
        scrim: { color: string; alpha: string };
        video?: string;
    };
    button?: {
        alignment?: string;
        background: {
            color?: string;
            image?: string;
        };
        height: string;
        width: string;
        title: CText;
        link: string;
        icon?: string;
        buttonLayout?: string;
    };
    title: CText;
    description: Array<string>;
    slider?: Array<SliderFeed>;
    meta?: { background: string };
    alignment: string;
    subtitle?: CText;
    feed?: Array<Feed>;
    endsIn: string;
    padding?: object;
}

export interface SliderFeed {
    banner: {
        image: string;
        link: string;
    };
    height?: string;
    width?: string;
    title: CText;
    subtitle?: CText;
    subtextV2?: CText;
    button?: {
        alignment?: string;
        background: {
            color?: string;
            image?: string;
        };
        height: string;
        width: string;
        title: CText;
        link: string;
        icon?: string;
        buttonLayout?: string;
    };
}

export interface Feed {
    banner: {
        image: string;
        link: string;
        video?: string;
    };
    title: CText;
    subtitle?: CText;
    button: {
        background: {
            color?: string;
            image?: string;
        };
        height: string;
        icon: string;
        link: string;
        title: CText;
        width: string;
        buttonLayout?: string;
    };
    subtext?: CText | string;
    subtextV2?: CText;
    active: boolean;
    link: string;
    categoryTab: {
        banner: {
            image: string;
            link: string;
        };
        productList: IProductList[];
        button: {
            background: {
                color?: string;
                image?: string;
            };
            height: string;
            icon: string;
            link: string;
            title: CText;
            width: string;
            buttonLayout?: string;
        };
    };
}

export interface IProductList {
    banner: {
        image: string;
        link: string;
    };
    title: CText;
}
